export default __webpack_public_path__ + "static/media/creating-contact-list-1.98014e12.png";